import * as React from 'react'

import { cn } from '@/lib/utils'

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, ...props }, ref) => (
  <input
    type={type}
    className={cn(
      'flex h-9 w-full rounded-md border border-slate-200 bg-white px-3 text-sm',
      'text-navy-900 placeholder:text-slate-400',
      'ring-offset-background transition-shadow duration-fluid ease-fluid',
      'file:mr-2 file:rounded file:border-0 file:bg-navy-100 file:px-2 file:py-1 file:text-xs file:font-medium file:text-navy-800 hover:file:bg-navy-200/80',
      'hover:border-navy-200',
      'focus-visible:outline-none focus-visible:border-navy-500 focus-visible:shadow-glow',
      'disabled:cursor-not-allowed disabled:bg-slate-50 disabled:opacity-60',
      'motion-reduce:transition-none',
      className,
    )}
    ref={ref}
    {...props}
  />
))
Input.displayName = 'Input'

export { Input }
